import React from "react";

const Header = () => {
    return (
        <header>
            <div className="logo">
                <h1>AIRASCA & ASOC.</h1>
                <p>Estudio Jurídico Integral e Inmobiliario</p>
            </div>
            <nav>
                <ul>
                    <li><a href="/">Inicio</a></li>
                    <li><a onClick={() => {
                        window.location.href = '/propiedades';
                    }}>Propiedades</a></li>
                    <li><a href="/about">Nosotros</a></li>
                </ul>
            </nav>
        </header>
    );
}

export default Header;